/* eslint-disable */
/* ⚠️ DO NOT EDIT ⚠️ */
/* This file is automatically generated, run 'pnpm codegen' to update */
import * as Types from '../../../__generated__/schema.types';

import { gql } from '@apollo/client';
export type CmDownloadFragment = { __typename?: 'CMDownloadImpl', id: string, viewtype?: string | null, type: string, title?: string | null, teaserTitle?: string | null, data?: { __typename?: 'Blob', contentType: string, size: number, uri?: string | null } | null };

export const CmDownloadFragmentDoc = gql`
    fragment CMDownload on CMDownload {
  id
  viewtype
  type
  title
  teaserTitle
  data {
    contentType
    size
    uri
  }
}
    `;